export const ROUTES = {
    HOME: '/home',
    SELF_SERVICES: '/self-auth/',
    INITIALIZE: '/init',
    ERROR: '/error/',
    AUTHENTICATION: '/verified',
    COOKIE_LINK: 'https://www.santander.de/datenschutz',
    FOOTER_CONTACT: 'https://www.santander.de/hotlines',
    FOOTER_SAFETY_INFO: 'https://www.santander.de/sicherheit',
    FOOTER_DATA_PROTECTION: 'https://www.santander.de/datenschutz',
    FOOTER_IMPRINT: 'https://www.santander.de/impressum',
    FOOTER_STORE_FINDER: 'https://www.santander.de/standortsuche',
    FOOTER_HELP: 'https://www.santander.de/hilfe'
}